import { useMemo } from "react";
import { C_REALESTATE_TYPES_PROJECT } from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";

export const useProjectTableColumns = (projectTypeId: number | undefined) => {
  return useMemo(() => {
    const typeId = projectTypeId || 0;
    return {
      name: true,
      bedrooms: [
        C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
        C_REALESTATE_TYPES_PROJECT.HOUSE.id,
        C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
      ].includes(typeId),
      bathrooms: [
        C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
        C_REALESTATE_TYPES_PROJECT.HOUSE.id,
        C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
        C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
      ].includes(typeId),
      parking_spots: [
        C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
        C_REALESTATE_TYPES_PROJECT.HOUSE.id,
        C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
        C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
      ].includes(typeId),
      sqm_construction: [
        C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
        C_REALESTATE_TYPES_PROJECT.HOUSE.id,
        C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
        C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
      ].includes(typeId),
      sqm_land: [
        C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
        C_REALESTATE_TYPES_PROJECT.HOUSE.id,
        C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
        C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id,
        C_REALESTATE_TYPES_PROJECT.LAND.id
      ].includes(typeId),
      floor_level: [
        C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
        C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id
      ].includes(typeId),
      halfBathrooms: false,
      price: true
    };
  }, [projectTypeId]);
};
